import { init, browserTracingIntegration } from '@sentry/react';

// Only enable sentry in production and webappgcp environment, and BUILD_ID is necessary.
const enableSentry =
  process.env.NODE_ENV === 'production' &&
  ['production', 'webappgcp'].includes(process.env.NODE_CONFIG_ENV) &&
  process.env.BUILD_ID;

// This's a hack function for sentry.
// Since Qiankun‘s sandbox overrides the original fetch, need to create a private fetch and override its `toString` function
function hackSentryFetch() {
  // eslint-disable-next-line @typescript-eslint/no-implied-eval
  const nativeFetch = new Function('return this.fetch')();
  const privateFetch: typeof fetch = function (...p) {
    return nativeFetch(...p);
  };

  privateFetch.toString = () => 'function fetch() { [native code] }';
  window.fetch = privateFetch;
}

export function start() {
  if (!enableSentry) return;

  hackSentryFetch();
  init({
    dsn: 'https://f98870916ac446c8aae0e15999ea9c0a@o123592.ingest.us.sentry.io/5712253',
    environment: process.env.NODE_CONFIG_ENV,
    release: `${process.env.PACKAGE_NAME}@${process.env.BUILD_ID}`,
    integrations: [browserTracingIntegration()],
    ignoreErrors: [/ResizeObserver loop/],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

export function stop() {
  if (!enableSentry) return;

  init({ dsn: '' });
}
